import React, { useEffect } from "react";
import { JerichoBlacksiteShell } from "../components/jericho/JerichoBlacksiteShell";
import { JerichoOperatorBar } from "../components/jericho/JerichoOperatorBar";

/**
 * Jericho — hidden restricted-access node page.
 * Reachable via the JerichoTerminal (triple-click logo OR type JERICHO on home).
 * Public route but obscure; not linked from any nav.
 *
 * The boot/passphrase modal lives in JerichoEasterEgg.jsx and is preserved as-is.
 * This page now renders inside a cinematic CIA black-site command dashboard shell.
 */
const DRAWERS = [
  {
    tag: "DRAWER 01",
    title: "Cold leads & dead drops",
    blurb:
      "Open questions and dangling threads that didn't make the public board — leads we've followed and abandoned, or are still chasing quietly.",
  },
  {
    tag: "DRAWER 02",
    title: "Alternate investigations",
    blurb:
      "Drafts of investigations outside the Epstein lattice. Operation Ajax. The Kennedy autopsy. Other long files waiting their turn.",
  },
  {
    tag: "DRAWER 03",
    title: "Editor's annex",
    blurb:
      "Internal correspondence, source notes, working hypotheses. Off-record context that informs the public files but never appears in them.",
  },
  {
    tag: "DRAWER 04",
    title: "Experimental archive",
    blurb:
      "Things we're testing — automated cross-reference passes, network drift analysis, source-credibility scoring. Some of it will graduate to the public board. Most won't.",
    disabled: true,
  },
];

const Jericho = ({ jerichoOperator }) => {
  return (
    <div data-testid="jericho-page">
      <JerichoOperatorBar operator={jerichoOperator} />
      <JerichoBlacksiteShell drawers={DRAWERS} />
    </div>
  );
};

export default Jericho;
